export default  {"src":"/_next/static/image/public/images/illustrations/collaboration.2c3a31358e633330b0cb390fc5ef050a.svg","height":1200,"width":1600};